import axios from "axios";
import { API } from "../lib/api";

const useApi = (getAuthHeader) => {
  const api = axios.create({ baseURL: API });

  api.interceptors.request.use((config) => {
    const authConfig = getAuthHeader();
    if (authConfig.headers) {
      config.headers = { ...config.headers, ...authConfig.headers };
    }
    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem("rs_token");
        localStorage.removeItem("rs_user");
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export default useApi;
